import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import tnimage from '../../utils/tnimage.png';
const Landing = ({ isAuthenticated }) => {
  
  if (isAuthenticated) {
    return <Redirect to='/dashboard' />;
  }
  
  return(        
        <section className="landing">
        <div className="dark-overlay">
          <div className="landing-inner">
          {/* <img src={tnimage} alt="tn"/> */}
            {/* <h2 className="text-primary">DIRECTORATE OF TECHNICAL EDUCATION</h2> */}
            <h5 className="text-danger" style={{fontWeight: "bold"}}>TNGASA 2026</h5>
            <h6 className="text-primary p-4" style={{color: "green", fontWeight: "bolder", border: "1px solid"}}>B.Ed ADMISSIONS</h6>
            
            {/* <div className="buttons">
              
              <Link to="/login" className="btn btn-primary" style={{color: "white"}} >Login</Link>
            </div> */}
          </div>
        </div>
      </section>        
    );
}

Landing.propTypes = {
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(Landing);
